import {
  preScreenInterview,
  postScreenInterview,
} from '../data/questionnaries';

export default [
  {
    title: 'View Post Assignment Board',
    type: 'ActionOpenAssignmentBoard',
    ref: 'assignmentBoard',
    for: ['host'],
    on: ['host'],
    group_only: false,
    hidden: true,
  },

  {
    title: 'Invite to new room',
    type: 'ActionInvites',
    ref: 'invites',
    // controls which user types can use this action
    for: ['host'],
    // controls which participants this action
    // can be taken on
    on: ['host', 'guest'],
  },
  {
    title: 'Create Group',
    type: 'ActionGroup',
    ref: 'group',
    for: ['host'],
    on: ['host', 'guest'],
    data: {},
  },

  {
    title: 'Control Entertainment',
    type: 'ActionEntertain',
    ref: 'entertain',
    for: ['host'],
    on: ['host', 'guest'],
    group_only: true,
    data: {
      videos: [
        {
          text: 'SAVE 100K in your TWENTIES',
          value: 'https://vmcdigital.wistia.com/medias/yvncmyx1do',
        },
      ],
      audios: [
        {
          text: 'Vector Marketing Podcast',
          value:
            'https://open.spotify.com/embed-podcast/show/40p4ohjKkSSTIecrRK7duM',
        },
      ],
    },
  },

  {
    title: 'Control Video',
    type: 'ActionVideo',
    ref: 'video',
    for: ['host'],
    on: ['host', 'guest'],
    group_only: true,
    data: {
      videos: [
        {
          text: 'What We Do 2025',
          value: 'https://vmcdigital.wistia.com/medias/253z7gev9y',
          //gave to everyone feb 4th
          //   if: (officePattern) => {
          //     const officePatterns = ['24', '26'];

          //     return officePatterns.some((pattern) => {
          //       return officePattern.startsWith(pattern);
          //     });
          //   },
        },
        {
          text: 'Getting Started + Pay 2025 Canada',
          value: 'https://vmcdigital.wistia.com/medias/cxh37x822p',
          //gave to everyone feb 4th
          if: (officePattern) => {
            return officePattern.startsWith('1');
          },
        },
        {
          text: 'Getting Started & Pay 2025',
          value: 'https://vmcdigital.wistia.com/medias/cffoj3ohc6',
          if: (officePattern) => {
            return !officePattern.startsWith('1');
          },
        },
        {
          text: 'Sales Program 2025',
          value: 'https://vmcdigital.wistia.com/medias/xg392p2i79',
          if: (officePattern) => {
            return !officePattern.startsWith('1');
          },
          //gave to everyone feb 4th
          //   if: (officePattern) => {
          //     const officePatterns = ['24', '26'];

          //     return officePatterns.some((pattern) => {
          //       return officePattern.startsWith(pattern);
          //     });
          //   },
        },
        {
          text: 'Sales Program 2025 – 3 Way Text',
          value: 'https://vmcdigital.wistia.com/medias/yw7mjq3ml4',
          //gave to everyone feb 4th
          //   if: (officePattern) => {
          //     const officePatterns = [
          //       '20',
          //       '21',
          //       '24',
          //       '26',
          //       '33',
          //       '37',
          //       '38',
          //       '47',
          //       '48',
          //       '53',
          //       '73',
          //       '75',
          //       '8A',
          //       '82',
          //       '84',
          //       '88',
          //     ];

          //     return officePatterns.some((pattern) => {
          //       return officePattern.startsWith(pattern);
          //     });
          // },
        },
        {
          text: 'SMRI Position Description (8 min)',
          value: 'https://vmcdigital.wistia.com/medias/icqw2iy5d7',
          if: (officePattern) => officePattern === '9149',
        },
        {
          text: 'Kuvaal Patel',
          value: 'https://vmcdigital.wistia.com/medias/f2qmlf4k78',
          if: (officePattern) => {
            return ['8069', '8061', '8060', '80H3', '80H2', '8079'].includes(
              officePattern
            );
          },
        },
        {
          text: 'Position Overview (9min)',
          value: 'https://vmcdigital.wistia.com/medias/68w4hzfsj6',
          if: (officePattern) => {
            return !officePattern.startsWith('1');
          },
        },
        {
          text: 'Pay Overview (5min)',
          value: 'https://vmcdigital.wistia.com/medias/heotu327dd',
          if: (officePattern) => {
            return !officePattern.startsWith('1');
          },
        },
        {
          text: 'Position Overview (20min)',
          value: 'https://vmcdigital.wistia.com/medias/w04488gx3a',
          if: (officePattern) => {
            return !officePattern.startsWith('1');
          },
        },
        {
          text: 'DVM Interview - Wes Frank',
          value: 'https://wesfrankcutco.wistia.com/medias/1juh07ugio',
          if: (officePattern) => {
            return (officePattern || '').startsWith('75');
          },
        },
        {
          text: 'Position Overview - Spanish (7min)',
          value: 'https://vmcdigital.wistia.com/medias/l9183bb4tr',
          if: (officePattern) => {
            return !officePattern.startsWith('1');
          },
        },
      ],
    },
  },

  {
    title: 'Show Presentation',
    type: 'ActionPresentation',
    ref: 'presentation',
    for: ['host'],
    on: ['host', 'guest'],
    group_only: true,
    data: {
      presentations: [
        {
          text: 'Work with Vector 2025',
          value:
            'https://vectordigitalstrategy.slides.com/vectorstrat/deck-1d2210',
          //   if: (officePattern) => {
          //     const officePatterns = ['24', '26'];

          //     return officePatterns.some((pattern) => {
          //       return officePattern.startsWith(pattern);
          //     });
          //   },
          //gave to everyone feb 4th
        },
        {
          text: 'Corporate Slide deck (USA)',
          value:
            'https://vectordigitalstrategy.slides.com/vectorstrat/learn-to-sell-cutco',
        },
        {
          text: 'Corporate Slide deck (Canada)',
          value: 'https://vectordigitalstrategy.slides.com/vectorstrat/deck',
        },
        {
          text: 'Presentation Example One',
          value: 'https://slides.com/news/make-better-presentations',
        },
      ],
    },
  },

  {
    title: 'Move to top',
    type: 'ActionPrioritize',
    ref: 'prioritize',
    for: ['host'],
    on: ['host'],
    group_only: false,
  },

  {
    title: 'Begin Pre- Screen',
    type: 'ActionPreScreen',
    ref: 'preScreen',
    for: ['host'],
    on: ['host', 'guest'],
    group_only: true,
    data: {
      questionnaire: [
        {
          text: preScreenInterview.label,
          value: 'preScreenInterview',
        },
      ],
      introVideo: [
        {
          text: 'APEX Welcome',
          value: 'https://vmcdigital.wistia.com/medias/4p0oh8shck',
        },
      ],
      outroAudio: [
        {
          text: 'Post-Questions Playlist',
          value:
            'https://w.soundcloud.com/player/?secret_token=s-fdDK0BV0rWs&show_artwork=true&url=https%3A%2F%2Fapi.soundcloud.com%2Fplaylists%2F1721934711&auto_play=true&hide_related=false&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&visual=false&sharing=false',
        },
      ],
      canControlMedia: false,
      showMedia: true,
    },
  },

  {
    title: 'Begin Post- Screen',
    type: 'ActionPostScreen',
    ref: 'postScreen',
    for: ['host'],
    on: ['host', 'guest'],
    group_only: true,
    data: {
      questionnaire: [
        {
          text: postScreenInterview.label,
          value: 'postScreenInterview',
        },
      ],
      outroVideo: [
        {
          text: 'Position Overview (9min)',
          value: 'https://vmcdigital.wistia.com/medias/68w4hzfsj6',
        },
        {
          text: 'SAVE 100K in your TWENTIES',
          value: 'https://vmcdigital.wistia.com/medias/yvncmyx1do',
        },
      ],
      outroAudio: [
        {
          text: 'Post-Questions Playlist',
          value:
            'https://w.soundcloud.com/player/?secret_token=s-fdDK0BV0rWs&show_artwork=true&url=https%3A%2F%2Fapi.soundcloud.com%2Fplaylists%2F1721934711&auto_play=true&hide_related=false&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&visual=false&sharing=false',
        },
      ],
      canControlMedia: true,
      showMedia: false,
    },
  },

  {
    title: 'Share Screen',
    type: 'ActionScreenShare',
    ref: 'share',
    for: ['host'],
    on: ['host', 'guest'],
    values: {},
  },

  {
    title: 'Control Volume',
    type: 'ActionControlVolume',
    ref: 'controlVolume',
    for: ['host'],
    on: ['host'],
    group_only: false,
  },
];
